import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "", testid }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
    data-testid={testid}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, testid, tone = "light" }) => (
  <Reveal testid={testid}>
    <div className="flex items-center gap-4">
      <span className={`font-mono text-xs font-semibold tracking-[0.3em] ${tone === "dark" ? "text-amber" : "text-[#181510]"}`}>{number}</span>
      <span className={`h-px w-10 ${tone === "dark" ? "bg-amber/60" : "bg-[#181510]/50"}`} />
      <span className={`font-mono text-xs uppercase tracking-[0.3em] ${tone === "dark" ? "text-white/50" : "text-[#181510]/70"}`}>{label}</span>
    </div>
  </Reveal>
);
